import { c as _c } from "react/compiler-runtime";
import { CreditViewMode } from "@custom-types/credit-types";
import { ExclamationMarkCircleFillIcon, Text } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { Stack } from "@mui-wrapper";
import { CreditsDialog } from "@pages/settings/subscription-settings/credits/credits-dialog";
/**
 * Shows the first upcoming expiration date among the available credit subscriptions list.
 * It provides a button to view all credit subscriptions in the form of a dialog.
 */
export function CreditSubscriptions(t0) {
  const $ = _c(15);
  const {
    earliestExpiringCredits,
    isExpiringSoon
  } = t0;
  const {
    formatDate
  } = useDateTime();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: 1,
      display: "flex",
      alignItems: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isExpiringSoon) {
    t3 = isExpiringSoon && <ExclamationMarkCircleFillIcon sx={{
      color: "warning.main",
      width: "20px",
      height: "20px"
    }} />;
    $[2] = isExpiringSoon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== earliestExpiringCredits || $[5] !== formatDate) {
    t4 = earliestExpiringCredits ? formatDate(earliestExpiringCredits?.expiresAt) : "-";
    $[4] = earliestExpiringCredits;
    $[5] = formatDate;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <var>{t4}</var>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <Text variant="bodyL" sx={t2}>{t3}{t5}</Text>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CreditsDialog buttonLabel="View purchases" initialViewMode={CreditViewMode.purchases} />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <Stack direction="row" sx={t1}>{t6}{t7}</Stack>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}